/*
 * Helper Methods to deal with redux-form's...idiosyncrasies
 * and gathering data about the samples
 */


export function getTubeIdsAsInt(rawId) {
  if (!rawId) return -10;
  var pattern = new RegExp(/_[\d]*$/g);
  var result = (pattern.exec(rawId));
  var processedId = result ? result[0].split('_') : [0, -10];
  return (typeof parseInt(processedId[1]) === 'number') ? parseInt(processedId[1]) : -10;
}

/* 
  'PUBLIC' constants
*/

export const tubeIdPrefix = 'TGI_';

export const postFields = [
  'sampling_date',
  'sample_name',
  'field',
  'farm',
  'treatments',
  'planting_stage',
  'previous_crop',
  'current_crop',
  'next_crop',
  'depth',
  'latitude',
  'longitude',
  'tube_id',
];

export const commonFields = [
  'farm',
  'field',
  'depth',
  'sampling_date',
  'planting_stage',
  'previous_crop',
  'next_crop',
  'current_crop'
];

/* 
  'PUBLIC' functions
*/

/**
 * 
 * @param {Object} allForms pass in the form slice of the redux store supplied by react-redux
 * @returns {Array} list of sanitized forms from the redux-form "form" slice 
 */
export function getSanitizedForms(allForms) {
  allForms = allForms || {};
  return Object.values(allForms).filter(formObj => {
    return formObj.hasOwnProperty('registeredFields');
  });
}

export function getLargestTubeId(allForms) {
  allForms = allForms || {};
  var goodForms = getSanitizedForms(allForms);
  const allTubeIds = Object.entries(goodForms).map(([formName, formObj]) => {
    if (!formObj.hasOwnProperty('values')) return 0;
    return formObj.values.tube_id;
  }).map(tubeid => getTubeIdsAsInt(tubeid));
  return allTubeIds.reduce((prevLargest, currentItem, index) => {
    return (currentItem > prevLargest) ? currentItem : prevLargest;
  }, -10);
}

/**
 * 
 * @param {Array} fieldList
 * @param {Object} formValues
 * @returns {Object} a form object samitized with values that appear in the supplied fieldsList 
 */
export function getFormValuesIntersection(fieldList, formValues) {
  var normalizedValues = {};
  if (!formValues.hasOwnProperty('values')) {
    return formValues;
  }
  for (var key in formValues.values) {
    if (fieldList.includes(key) && formValues.values.hasOwnProperty(key)) {
      normalizedValues[key] = formValues.values[key];
    }
  }
  return normalizedValues;
}

/**
 * 
 * @param {Object} allForms 
 * @returns {number} number forms in the sanitized forms from the redux-form "form" slice 
 */
export function getNumberOfForms(allForms) {
  let sanitizedForms = getSanitizedForms(allForms);
  return sanitizedForms.length ? sanitizedForms.length : 0;
}

export function getSampleStatus({ submission_uuid, processed }) {
  var status = 'Not Submitted';
  if (!submission_uuid) status = 'Not Submitted';
  if (submission_uuid && processed) status = 'Processed';
  if (submission_uuid && !processed) status = 'Submitted';
  return status;
}


/**
 * removes the dummy sample id field so a post will be issued and a new sample will be recorded in the database
 * @param {string} sample 
 */
export function formatForPost(sample) {
  var formattedSample = { ...sample };
  // can remove sample id
  if (formattedSample.id) { delete formattedSample.id }

  if (!formattedSample.sampling_date) { delete formattedSample.sampling_date }

  formattedSample.latitude = sample.latitude ? sample.latitude : null;
  formattedSample.longitude = sample.longitude ? sample.longitude : null;

  for (var property in formattedSample) {
    if (!postFields.includes(property)) {
      delete formattedSample[property];
    }

  }

  // Now format treatment tags appropriately
  if (formattedSample.treatments || sample.treatments) {
    var formattedTreatments = sample.treatments.map((t) => {
      if (typeof t === 'object') {
        return t.name;
      } else {
        return t;
      }
    });
    formattedSample.treatments = formattedTreatments;
  }

  return formattedSample;
}
